import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "urgent"
}
const _hoisted_2 = { class: "lines" }
const _hoisted_3 = { class: "times" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "ticket" }
const _hoisted_6 = { class: "foot" }

import {computed} from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityCouponCard',
  props: {
    config: null,
    compact: { type: Boolean, default: false },
    concise: { type: Boolean, default: false }
  },
  emits: ["view"],
  setup(__props: any) {

const props = __props as { config:any, compact:boolean, concise:boolean };



const urgent=computed(()=>props.config.endTime-Date.now()<=props.config.urgentHours*3600000)
const format=(v:number)=>v?new Date(v).toLocaleString('zh-CN',{hour12:false}):''

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(['client-activity',__props.config.base,{'client-activity-compact':__props.compact,'client-activity-concise':__props.concise}])
  }, [
    _renderSlot(_ctx.$slots, "before"),
    (__props.concise)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("h2", null, _toDisplayString(__props.config.title), 1),
          _renderSlot(_ctx.$slots, "summary"),
          _renderSlot(_ctx.$slots, "actions")
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_unref(urgent))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.config.urgentText), 1))
            : _createCommentVNode("", true),
          _createElementVNode("small", null, _toDisplayString(__props.config.eyebrow), 1),
          _createElementVNode("h2", null, _toDisplayString(__props.config.title), 1),
          _createElementVNode("p", _hoisted_2, _toDisplayString((__props.config.lines || []).join('\n')), 1),
          _createElementVNode("p", _hoisted_3, [
            _createTextVNode(_toDisplayString(__props.config.startLabel) + " " + _toDisplayString(format(__props.config.startTime)), 1),
            _hoisted_4,
            _createTextVNode(_toDisplayString(__props.config.endLabel) + " " + _toDisplayString(format(__props.config.endTime)), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("strong", null, _toDisplayString(__props.config.amount), 1),
              _createElementVNode("small", null, _toDisplayString(__props.config.threshold), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("b", null, _toDisplayString(__props.config.couponTitle), 1),
              _createElementVNode("small", null, _toDisplayString(__props.config.scope), 1)
            ])
          ]),
          _createElementVNode("button", {
            class: "cta",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('view')))
          }, _toDisplayString(__props.config.buttonText), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(__props.config.footnote), 1)
        ], 64)),
    _renderSlot(_ctx.$slots, "after")
  ], 2))
}
}

})